module.exports = __webpack_public_path__ + "static/media/logo-white.5f300f15.svg";